import React, { useEffect, useState } from "react";



 import {
    getLegislativeItems,
    getLegislativeItem,
    createLegislativeItem,
    updateLegislativeItem,
    toggleLegislativeFeatured,
    toggleLegislativeActive,
    deleteLegislativeItem,
} from "../../services/adminApi";


const emptyForm = {
    title: "",
    short_description: "",
    description: "",
    icon: "",
    featured: false,
    active: true,
};

const AdminLegislative = () => {

    const [items, setItems] = useState([]);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const [page, setPage] = useState(1);
    const [perPage] = useState(10);

    const [pagination, setPagination] = useState(null);

    const [filters, setFilters] = useState({
        search: "",
        featured: "",
        active: "",
    });

    const [showForm, setShowForm] = useState(false);

    const [editingId, setEditingId] = useState(null);

    const [form, setForm] = useState(emptyForm);


    /*
    |--------------------------------------------------------------------------
    | Load Legislative Items
    |--------------------------------------------------------------------------
    */

    const loadItems = async () => {

        try {

            setLoading(true);
            setError("");

            const response =
                await getLegislativeItems(
                    page,
                    perPage,
                    filters
                );

                
 
            setItems(
                response.data.data || []
            );

            setPagination(
                response.meta || response.pagination || null
            ); 

        } catch (err) {

            setError(
                err.message ||
                "Unable to load legislative items."
            );

        } finally {

            setLoading(false);

        }
    };


    useEffect(() => {

        loadItems();

    }, [
        page,
        filters.search,
        filters.featured,
        filters.active,
    ]);


    /*
    |--------------------------------------------------------------------------
    | Form
    |--------------------------------------------------------------------------
    */

    const handleChange = (e) => {

        const {
            name,
            value,
            type,
            checked,
        } = e.target;

        setForm(prev => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : value,
        }));
    };


    const openCreate = () => {

        setEditingId(null);

        setForm(emptyForm);

        setError("");
        setSuccess("");

        setShowForm(true);
    };


    const openEdit = async (id) => {

        try {

            setError("");

            const response =
                await getLegislativeItem(id);

            const item =
                response.data;

            setEditingId(id);

            setForm({
                title:
                    item.title || "",

                short_description:
                    item.short_description || "",

                description:
                    item.description || "",

                icon:
                    item.icon || "",

                featured:
                    Boolean(item.featured),

                active:
                    Boolean(item.active),
            });

            setShowForm(true);

        } catch (err) {

            setError(
                err.message ||
                "Unable to load legislative item."
            );

        }
    };


    const closeForm = () => {

        if (saving) return;

        setShowForm(false);

        setEditingId(null);

        setForm(emptyForm);
    };


    /*
    |--------------------------------------------------------------------------
    | Save
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async (e) => {

        e.preventDefault();

        alert("what is the problen");

        try {

            setSaving(true);

            setError("");
            setSuccess("");

            if (editingId) {

                await updateLegislativeItem(
                    editingId,
                    form
                );

                setSuccess(
                    "Legislative item updated successfully."
                );

            } else {

               

              let response = await createLegislativeItem(
                    form
                );



                alert(JSON.stringify(response.data));

                setSuccess(
                    "Legislative item created successfully."
                );
            }

            setShowForm(false);

            setEditingId(null);

            setForm(emptyForm);

            await loadItems();

        } catch (err) {

            setError(
                err.message ||
                "Unable to save legislative item."
            );

        } finally {

            setSaving(false);

        }
    };


    /*
    |--------------------------------------------------------------------------
    | Featured
    |--------------------------------------------------------------------------
    */

    const handleFeatured = async (id) => {

        try {

            await toggleLegislativeFeatured(id);

            await loadItems();

        } catch (err) {

            setError(
                err.message ||
                "Unable to update featured status."
            );
        }
    };


    /*
    |--------------------------------------------------------------------------
    | Active
    |--------------------------------------------------------------------------
    */

    const handleActive = async (id) => {

        try {

            await toggleLegislativeActive(id);

            await loadItems();

        } catch (err) {

            setError(
                err.message ||
                "Unable to update active status."
            );
        }
    };


    /*
    |--------------------------------------------------------------------------
    | Delete
    |--------------------------------------------------------------------------
    */

    const handleDelete = async (id) => {

        const confirmed =
            window.confirm(
                "Are you sure you want to delete this legislative item?"
            );

        if (!confirmed) return;

        try {

            setError("");

            await deleteLegislativeItem(id);

            setSuccess(
                "Legislative item deleted successfully."
            );

            await loadItems();

        } catch (err) {

            setError(
                err.message ||
                "Unable to delete legislative item."
            );
        }
    };


    /*
    |--------------------------------------------------------------------------
    | Filters
    |--------------------------------------------------------------------------
    */

    const handleFilterChange = (e) => {

        const {
            name,
            value,
        } = e.target;

        setPage(1);

        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };


    /*
    |--------------------------------------------------------------------------
    | Pagination
    |--------------------------------------------------------------------------
    */

    const goToPage = (newPage) => {

        if (newPage < 1) return;

        if (
            pagination?.last_page &&
            newPage > pagination.last_page
        ) {
            return;
        }

        setPage(newPage);
    };


    return (
        <div className="admin-legislative-page">

            {/* =====================================================
                HEADER
            ===================================================== */}

            <div className="admin-page-header">

                <div>

                    <span className="admin-page-eyebrow">
                        CONTENT MANAGEMENT
                    </span>

                    <h2>
                        Legislative <em>Priorities</em>
                    </h2>

                    <p>
                        Manage the legislative priorities,
                        initiatives and policy positions
                        displayed on the website.
                    </p>

                </div>

                <button
                    type="button"
                    className="admin-primary-button"
                    onClick={openCreate}
                >
                    <span>+</span>
                    Add Legislative Item
                </button>

            </div>


            {/* =====================================================
                MESSAGES
            ===================================================== */}

            {error && (
                <div className="admin-form-error">
                    {error}
                </div>
            )}

            {success && (
                <div className="admin-form-message">
                    {success}
                </div>
            )}


            {/* =====================================================
                FORM
            ===================================================== */}

            {showForm && (

                <div className="admin-panel admin-legislative-form">

                    <div className="admin-panel-header">

                        <div>

                            <span>
                                {editingId
                                    ? "EDIT ITEM"
                                    : "NEW ITEM"}
                            </span>

                            <h3>
                                {editingId
                                    ? "Edit Legislative Item"
                                    : "Add Legislative Item"}
                            </h3>

                        </div>

                        <button
                            type="button"
                            className="admin-secondary-button"
                            onClick={closeForm}
                        >
                            Close
                        </button>

                    </div>


                    <form
                        className="admin-form"
                        onSubmit={handleSubmit}
                    >

                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Title
                                </label>

                                <input
                                    type="text"
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                    placeholder="e.g. Education Reform"
                                    required
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    Icon
                                </label>

                                <input
                                    type="text"
                                    name="icon"
                                    value={form.icon}
                                    onChange={handleChange}
                                    placeholder="e.g. fa-graduation-cap"
                                />

                            </div>

                        </div>


                        <div className="admin-form-group">

                            <label>
                                Short Description
                            </label>

                            <textarea
                                name="short_description"
                                value={
                                    form.short_description
                                }
                                onChange={handleChange}
                                placeholder="Brief description of this legislative priority..."
                                rows="3"
                            />

                        </div>


                        <div className="admin-form-group">

                            <label>
                                Description
                            </label>

                            <textarea
                                name="description"
                                value={
                                    form.description
                                }
                                onChange={handleChange}
                                placeholder="Full description..."
                                rows="7"
                            />

                        </div>


                        <div className="admin-project-toggles">

                            <label className="admin-toggle">

                                <input
                                    type="checkbox"
                                    name="featured"
                                    checked={form.featured}
                                    onChange={handleChange}
                                />

                                <span className="admin-toggle-slider" />

                                <div>
                                    <strong>
                                        Featured
                                    </strong>

                                    <small>
                                        Highlight this item
                                        on the website.
                                    </small>
                                </div>

                            </label>


                            <label className="admin-toggle">

                                <input
                                    type="checkbox"
                                    name="active"
                                    checked={form.active}
                                    onChange={handleChange}
                                />

                                <span className="admin-toggle-slider" />

                                <div>
                                    <strong>
                                        Active
                                    </strong>

                                    <small>
                                        Display this item
                                        publicly.
                                    </small>
                                </div>

                            </label>

                        </div>


                        <div className="admin-career-form-actions">

                            <button
                                type="submit"
                                className="admin-primary-button"
                                disabled={saving}
                            >
                                {saving
                                    ? "Saving..."
                                    : editingId
                                        ? "Update Item"
                                        : "Create Item"}
                            </button>

                            <button
                                type="button"
                                className="admin-secondary-button"
                                onClick={closeForm}
                                disabled={saving}
                            >
                                Cancel
                            </button>

                        </div>

                    </form>

                </div>
            )}


            {/* =====================================================
                FILTERS
            ===================================================== */}

            <div className="admin-panel legislative-filter-card">

                <div>

                    <label>
                        Search
                    </label>

                    <input
                        type="search"
                        name="search"
                        value={filters.search}
                        onChange={handleFilterChange}
                        placeholder="Search legislative items..."
                    />

                </div>


                <div>

                    <label>
                        Featured
                    </label>

                    <select
                        name="featured"
                        value={filters.featured}
                        onChange={handleFilterChange}
                    >

                        <option value="">
                            All
                        </option>

                        <option value="1">
                            Featured
                        </option>

                        <option value="0">
                            Not Featured
                        </option>

                    </select>

                </div>


                <div>

                    <label>
                        Status
                    </label>

                    <select
                        name="active"
                        value={filters.active}
                        onChange={handleFilterChange}
                    >

                        <option value="">
                            All
                        </option>

                        <option value="1">
                            Active
                        </option>

                        <option value="0">
                            Inactive
                        </option>

                    </select>

                </div>

            </div>


            {/* =====================================================
                LIST
            ===================================================== */}

            <div className="admin-panel">

                <div className="admin-panel-header">

                    <div>

                        <span>
                            LEGISLATIVE MANAGEMENT
                        </span>

                        <h3>
                            Legislative Items
                        </h3>

                    </div>

                    <span className="admin-record-count">
                        {items.length} items
                    </span>

                </div>


                {loading ? (

                    <div className="admin-page-loading">
                        Loading legislative items...
                    </div>

                ) : items.length === 0 ? (

                    <div className="admin-empty-state">

                        <p>
                            No legislative items found.
                        </p>

                        <button
                            className="admin-primary-button"
                            onClick={openCreate}
                        >
                            <span>+</span>
                            Add First Item
                        </button>

                    </div>

                ) : (

                    <div className="admin-legislative-list">

                        {items.map(item => (

                            <div
                                className="admin-legislative-item"
                                key={item.id}
                            >

                                <div className="admin-legislative-icon">

                                    {item.icon || "§"}

                                </div>


                                <div className="admin-legislative-content">

                                    <div className="admin-legislative-title">

                                        <h3>
                                            {item.title}
                                        </h3>

                                        {item.featured && (
                                            <span className="admin-featured-badge">
                                                FEATURED
                                            </span>
                                        )}

                                    </div>

                                    <p>
                                        {item.short_description ||
                                            item.description ||
                                            "No description provided."}
                                    </p>

                                </div>


                                <div className="admin-legislative-status">

                                    <button
                                        type="button"
                                        className={
                                            `admin-status-badge ${
                                                item.active
                                                    ? "published"
                                                    : "draft"
                                            }`
                                        }
                                        onClick={() =>
                                            handleActive(item.id)
                                        }
                                    >
                                        {item.active
                                            ? "ACTIVE"
                                            : "INACTIVE"}
                                    </button>

                                </div>


                                <button
                                    type="button"
                                    className={
                                        `news-featured-toggle ${
                                            item.featured
                                                ? "active"
                                                : ""
                                        }`
                                    }
                                    title={
                                        item.featured
                                            ? "Remove from featured"
                                            : "Mark as featured"
                                    }
                                    onClick={() =>
                                        handleFeatured(item.id)
                                    }
                                >
                                    ★
                                </button>


                                <div className="admin-legislative-actions">

                                    <button
                                        type="button"
                                        onClick={() =>
                                            openEdit(item.id)
                                        }
                                    >
                                        Edit
                                    </button>

                                    <button
                                        type="button"
                                        className="delete"
                                        onClick={() =>
                                            handleDelete(item.id)
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </div>

                        ))}

                    </div>

                )}


                {/* =================================================
                    PAGINATION
                ================================================= */}

                {!loading &&
                    pagination &&
                    pagination.last_page > 1 && (

                        <div className="admin-pagination">

                            <div className="admin-pagination-summary">

                                Showing{" "}

                                <strong>
                                    {pagination.from}
                                </strong>

                                {" "}to{" "}

                                <strong>
                                    {pagination.to}
                                </strong>

                                {" "}of{" "}

                                <strong>
                                    {pagination.total}
                                </strong>

                            </div>


                            <div className="admin-pagination-controls">

                                <button
                                    disabled={
                                        page <= 1
                                    }
                                    onClick={() =>
                                        goToPage(page - 1)
                                    }
                                >
                                    Previous
                                </button>


                                {Array.from(
                                    {
                                        length:
                                            pagination.last_page,
                                    },
                                    (_, index) => index + 1
                                ).map(number => (

                                    <button
                                        key={number}
                                        className={
                                            page === number
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() =>
                                            goToPage(number)
                                        }
                                    >
                                        {number}
                                    </button>

                                ))}


                                <button
                                    disabled={
                                        page >=
                                        pagination.last_page
                                    }
                                    onClick={() =>
                                        goToPage(page + 1)
                                    }
                                >
                                    Next
                                </button>

                            </div>

                        </div>

                    )}

            </div>

        </div>
    );
};

export default AdminLegislative;